import { Blockquote } from "./Blockquote";
import { Markdown } from "./Markdown";
import { Paragraph, Text } from "./Text";
import { useColors } from "./useColors";

const Line = ({ speaker, text }: { speaker?: string; text: string }) => {
  const { subtitleColor } = useColors();

  if (!speaker) {
    return <Markdown content={text} inline={true} />;
  }

  return (
    <>
      <Text as="span" color={subtitleColor} fontFamily="sans" textStyle="sc">
        {speaker}:
      </Text>{" "}
      <Markdown content={text} inline={true} />
    </>
  );
};

export const Dialogue = ({
  content,
  short = false,
}: {
  content: string;
  short: boolean;
}) => {
  const lines = content
    .trim()
    .split("\n\n")
    .map((line) => {
      const splits = line.split(": ");
      if (splits.length > 1) {
        const [speaker, ...rest] = line.split(": ");
        return { speaker, text: rest.join(": ") };
      }
      return { speaker: undefined, text: line };
    });

  return (
    <Blockquote>
      {lines.map(({ speaker, text }, i) => (
        <Paragraph key={i} my={short ? "0.6em" : "parSpace"}>
          <Line speaker={speaker} text={text} />
        </Paragraph>
      ))}
    </Blockquote>
  );
};

export const RLDialogue = ({ content }: { content: string }) => {
  const lines = content
    .trim()
    .split("\n\n")
    .map((line) => {
      const splits = line.split(": ");
      if (splits.length > 1) {
        const [align, ...rest] = line.split(": ");
        const text = rest.join(": ");
        if (align.toUpperCase() === "R") {
          return { align: "right" as const, text };
        }
        return { align: "left" as const, text };
      }
      return { align: "left" as const, text: line };
    });

  return (
    <>
      {lines.map(({ align, text }, i) => (
        <Paragraph key={i} align={align}>
          <Markdown content={text} inline={true} />
        </Paragraph>
      ))}
    </>
  );
};
